export enum enParameters {
  a = 'a',                        // id do afiliado
  action = 'action',              // parâmetro para uso da recuperação
  b = 'b',                        // exibe ou esconde a opção de pagar com boleto
  bs = 'bs',                      // Gera um novo boleto
  cel = 'cel',                    // preenche telefone do cliente
  cep = 'cep',                    // ja preenche o cep
  comp = 'comp',                  // preenche complemento do endereço do cliente
  cp = 'cp',                      // número mínimo de parcelas
  cupom = 'cupom',                // Para aplicar cupoms
  dd = 'dd',                      // seta a data de vencimento do boleto
  doc = 'doc',                    // preenche o documento do cliente
  dv = 'dv',                      // muda o numero de dias do vencimento da fatura
  ec = 'ec',                      // Este Parâmetro está Desativado
  email = 'email',                // email do cliente
  he = 'he',                      // OCB
  info = 'info',                  // Este Parâmetro está Desativado
  lang = 'lang',                  // set language
  lastKey = 'lastKey',            // key da transação anterior usada para o upsell de boleto
  name = 'name',                  // preenche nome do cliente
  np = 'np',                      // número máximo de parcelas
  nome = 'nome',                  // preenche nome do cliente
  num = 'num',                    // preenche número do endereço do cliente
  p = 'p',                        // vem com uma parcela selecionada
  pe = 'pe',                      // número exato de parcelas
  pf = 'pf',                      // obriga o cliente a selecionar o numero de parcelas, ou seja, não vem selecionada nenhuma parcela por padrão
  phone = 'phone',                // preenche telefone do cliente
  pr = 'pr',                      // inverte ordem de parcelas
  pu = 'pu',                      // Parcela única, venda somente à vista
  df = 'df',                      // documento de pessoa física, apenas aceita CPF
  dj = 'dj',                      // documento de pessoa jurídica, apenas aceita CNPJ
  sdoc = 'sdoc',                  // Exibe campo de documento para compras nacionais (CPF/CNPJ) para produtos gratuitos
  pxidfb = 'pxidfb',              // pixel do facebook (no momento está desativado)
  pxvlfb = 'pxvlfb',              // pixel do facebook (no momento está desativado)
  session = 'session',            // Este Parâmetro está Desativado
  sid = 'sid',                    // Este Parâmetro está Desativado
  templateId = 'templateId',      // id do template
  u = 'u',                        // upsell
  upsell = 'upsell',              // upsell boleto
  ukey = 'ukey',                  // chave do upsell
  utmCampaign = 'utmCampaign',    // exemplo: ?utm_campaign=campanha1 -> isso mapeia por meio de onde o produto foi vendido
  utmContent = 'utmContent',      // exemplo: ?utm_content=conteudo12 -> isso mapeia por meio de onde o produto foi vendido
  utmMedium = 'utmMedium',        // exemplo: ?utm_medium=medium1     -> isso mapeia por meio de onde o produto foi vendido
  utmSource = 'utmSource',        // exemplo:  ?utm_source=facebook   -> isso mapeia por meio de onde o produto foi vendido
  trk = 'trk',                    // Tem o mesmo intuito das Utms, porém, é interno da eduzz
  trk2 = 'trk2',                  // Tem o mesmo intuito das Utms, porém, é interno da eduzz
  trk3 = 'trk3',                  // Tem o mesmo intuito das Utms, porém, é interno da eduzz
  zip = 'zip',                    // Preenche Zip Code do cliente
  wd = 'wd',                      // Este Parâmetro está Desativado
  skip = 'skip',                  // Pula preenchimento de dados do cliente
  config = 'config',              // Parâmetro para aplicar configurações de template no checkout
  qaparam = 'qaparam',            // Para forçar o uso de um PSP específico
  qaflow = 'qaflow',              // Parâmetro ainda desconhecido, caso tenha informações atualiza aqui pra gente =]
  pm = 'pm',                      // Este Parâmetro está Desativado
  c = 'c'                         // Este Parâmetro está Desativado
}
